<div>
    <div class="row" style="margin:0px" >
        <span class="modal-sub-header">
            Select Prescribers: 
            <span class="modal-sub-header" 
                    style="margin-left: 10px;">
                    <a (click)="selectAllPrescribers()">Select All</a>
            </span>
            <span class="modal-sub-header" style="float: right;">
                {{selectedPrescriberCount}} selected
            </span>
        </span>
        <div>
            <input type="search" 
                   [(ngModel)]="searchText"
                   (ngModelChange)="searchPrescribers($event)" 
                   placeholder="Search" 
                   style="width: 330px; margin-bottom: 10px">
        </div>
        <div class="scrollable-content-area">
            <div *ngFor="let prescriber of filteredPrescribers" class="facility">
                <label [class]="areAllPrescribersSelected ? 'checkbox-square' : 'checkbox'">
                    <input type="checkbox" 
                            (change)="selectPrescriber()" 
                            [(ngModel)]="prescriber.IsSelected" >
                    <span></span>
                    <span class="checkbox-label">{{prescriber.FullName}}</span>
                </label>
            </div>
        </div>
    </div>
</div>